import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import ProviderSegmentationList from '../../ProviderSegmentationList';
import ProviderSegmentationInfo from '../../ProviderSegmentationInfo';
import ProviderPromoCodeList from '../../ProviderPromoCodeList';
import ProviderPromoCodeInfo from '../../ProviderPromoCodeInfo';
import ProviderPendingUserList from '../../ProviderPendingUserList';
import AccountUserEdit from '../../AccountUserEdit';

import Button from '../../../shared/components/Button';
import RetailerInfo from "../../RetailerInfo";
import RetailerView from "../../RetailerView";
import RetailerList from "../../RetailerList";
import MilestonesList from "../../MilestonesList";
import EditMilestone from "../../EditMilestone";
import RewardPromoList from "../../RewardPromoList";
import EditRewardPromo from "../../EditRewardPromo";

class ProviderConfiguration extends Component {
  constructor(props){
    super(props);

    this.state = {
      isLoaded:false,
      error:null
    };
  }

  componentDidMount(){
    //TODO: Load data from server for ProviderConfiguration in componentDidMount
    Promise
      .all([])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  componentWillUnmount(){
    //TODO: Cleanup after ProviderConfiguration in componentWillUnmount
  }

  render(){
    const { match } = this.props

    return (
      <Container>
        <Row>
          <Col xs='6'>
            <br />
            <h6>Internal use only!</h6>
            <h3>Configuration</h3>
            <br />
          </Col>
          <Col xs='6' className='clearfix'>
            <br />
            <br />
            <div className='pull-right'>
              <Switch>
                <Route
                  exact path={`${match.url}/distributions`}
                  render={() => (
                    <Button 
                      linkHref={`${match.url}/distributions/new`}
                      disabled
                    >
                      Create Segmentation
                    </Button>
                  )}
                />
                <Route
                  exact path={`${match.url}/promocodes`}
                  render={() => (
                    <Button linkHref={`${match.url}/promocodes/new`}>
                      Create Promo Code
                    </Button>
                  )}
                />
                <Route
                    exact path={`${match.url}/messages`}
                    render={() => (
                        <Button linkHref={`${match.url}/messages/new`}>
                          Create Message
                        </Button>
                    )}
                />
                <Route
                    exact path={`${match.url}/rewardpromos`}
                    render={() => (
                        <Button linkHref={`${match.url}/rewardpromos/new`}>
                          Schedule Promotion
                        </Button>
                    )}
                />
              </Switch>
            </div>
            <br />
          </Col>

        </Row>
        <Row>
          <Col xs='12'>
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/distributions`}
                  activeClassName='active'
                >
                  Segmentations
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/promocodes`}
                  activeClassName='active'
                >
                  Promo Codes
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/pendingusers`}
                  activeClassName='active'
                >
                  Pending Users
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                    tag={Link}
                    to={`${match.url}/retailers`}
                    activeClassName='active'
                >
                  &nbsp;&nbsp;Publishers
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                    tag={Link}
                    to={`${match.url}/messages`}
                    activeClassName='active'
                >
                  &nbsp;&nbsp;Messages
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                    tag={Link}
                    to={`${match.url}/rewardpromos`}
                    activeClassName='active'
                >
                  &nbsp;&nbsp;Reward Promos
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <br />
        <Switch>
          <Route path={`${match.url}/distributions/new`} component={ProviderSegmentationInfo} />
          <Route path={`${match.url}/distributions/:distributionId/edit`} component={ProviderSegmentationInfo} />
          <Route path={`${match.url}/distributions`} component={ProviderSegmentationList} />
          <Route path={`${match.url}/promocodes/new`} component={ProviderPromoCodeInfo} />
          <Route path={`${match.url}/promocodes/:promoCodeId/edit`} component={ProviderPromoCodeInfo} />
          <Route path={`${match.url}/promocodes`} component={ProviderPromoCodeList} />
          <Route path={`${match.url}/pendingusers`} component={ProviderPendingUserList} />
          <Route path={`${match.url}/retailers/new`} component={RetailerInfo} />
          <Route path={`${match.url}/retailers/:retailerId`} component={RetailerView} />
          <Route path={`${match.url}/retailers`} component={RetailerList} />
          <Route path={`${match.url}/messages/:milestoneId`} component={EditMilestone} />
          <Route path={`${match.url}/messages`} component={MilestonesList} />
          <Route path={`${match.url}/rewardpromos/:promoId`} component={EditRewardPromo} />
          <Route path={`${match.url}/rewardpromos`} component={RewardPromoList} />
        </Switch>
      </Container>
    );
  }
}

ProviderConfiguration.propTypes = {
  //TODO: Fill in prop types for ProviderConfiguration
};

ProviderConfiguration.defaultProps = {
  //TODO: Fill in defaultProps for ProviderConfiguration
};

export default ProviderConfiguration;



// WEBPACK FOOTER //
// ./src/routes/ProviderConfiguration/components/ProviderConfiguration.js